import React, { Component } from "react";
import { Dropdown } from "../../../../Components/Dropdown";
import { MenuItem } from "../../../../Components/Menu";
import { LANGUAGES } from "../../../../../common/languages";

export class LanguagePicker extends Component {
    render() {
        const { value, onChange, includeAuto = true } = this.props;

        return (
            <Dropdown value={value} onChange={onChange}>
                {includeAuto && <MenuItem value="auto">Auto Detect</MenuItem>}
                {LANGUAGES.map(lang => (
                    <MenuItem key={lang.code} value={lang.code}>{lang.language}</MenuItem>
                ))}
            </Dropdown>
        );
    }
}

